import React, { useEffect } from "react";

function test(props) {
  useEffect(() => {
    init()
  }, [])

  const init = () => {
    var useragt = navigator.userAgent.toLowerCase();
    var target_url = 'https://lgchem-oce--uat.sandbox.my.site.com/lgconnect/s/';
    if(useragt.match(/kakaotalk/i)){
        
        //카카오톡 외부브라우저로 호출
        try{
            location.replace('kakaotalk://web/openExternal?url='+encodeURIComponent(target_url));
        }catch(e){
            alert(e)
        }
        
    }
  }

  return (
    <div></div>
  );
}

export default test;
